// extracted by mini-css-extract-plugin
export default {"container":"BottomBar_container__X9DHF"};